<template>
    <Modal
        :onClose="handleClose"
        :title="t({ key: 'shared.important_information' })"
        padding="m"
        size="l">
        <div
            v-for="(note, index) in notes"
            :key="`${note.roomDescription[0]}-${index}`"
            class="room">
            <div v-if="note.accommodationNote">
                <div class="room-description">{{ note.roomDescription }}</div>
                <div class="room-note" v-html="sanitize(note.accommodationNote)" />
            </div>
        </div>
    </Modal>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, PropType } from 'vue';
    import { sanitize } from '@shared/utils/sanitize';
    import { Note } from '@ui/components/ProductCard/ProductCard.interfaces';
    import Modal from '@ui/components/Modal/Modal.vue';

    export default defineComponent({
        name: 'SupplierNotesModal',
        methods: { t, sanitize },
        components: { Modal },
        props: {
            notes: {
                type: Array as PropType<Note[]>,
                required: true,
            },
            onClose: Function,
        },
        setup(props) {
            const handleClose = () => {
                props.onClose && props.onClose();
            };

            return { handleClose };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'SupplierNotes.scss';
</style>
